import { IconHelpCircle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import type { Clarification, ClarificationOption } from '../parser';

type Props = {
  question: Clarification;
  onResolve: (option: ClarificationOption) => void;
  onManual: () => void;
  onDismiss: () => void;
};

export function QuestionCard({ question, onResolve, onManual, onDismiss }: Props) {
  const { t } = useTranslation();
  return (
    <div className="question" role="alert">
      <div className="row" style={{ alignItems: 'flex-start', flexWrap: 'nowrap' }}>
        <IconHelpCircle size={20} color="var(--warning)" style={{ flex: 'none', marginTop: 2 }} />
        <div className="grow">
          <strong>{question.question}</strong>
          {question.transcript && <div className="question__quote">„{question.transcript}”</div>}
        </div>
      </div>
      <div className="chips">
        {question.options.map((o) => (
          <button
            key={o.label}
            type="button"
            className="btn btn--dark btn--sm"
            onClick={() => onResolve(o)}
          >
            {o.label}
          </button>
        ))}
        <button type="button" className="btn btn--sm" onClick={onManual}>
          {t('dictation.manual')}
        </button>
        <button type="button" className="btn btn--ghost btn--sm" onClick={onDismiss}>
          {t('dictation.dismiss')}
        </button>
      </div>
    </div>
  );
}
